var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditsImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coins-stacked-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.4596 4.79167C12.4596 5.85021 10.0998 6.70833 7.1888 6.70833C4.2778 6.70833 1.91797 5.85021 1.91797 4.79167M12.4596 4.79167C12.4596 3.73312 10.0998 2.875 7.1888 2.875C4.2778 2.875 1.91797 3.73312 1.91797 4.79167M12.4596 4.79167V6.22917M1.91797 4.79167V16.2917C1.91797 17.3502 4.2778 18.2083 7.1888 18.2083M7.1888 10.5417C7.02728 10.5417 6.86745 10.539 6.70963 10.5339C4.02319 10.4458 1.91797 9.62481 1.91797 8.625M7.1888 14.375C4.2778 14.375 1.91797 13.5169 1.91797 12.4583M21.0846 11.0208C21.0846 12.0794 18.7248 12.9375 15.8138 12.9375C12.9028 12.9375 10.543 12.0794 10.543 11.0208M21.0846 11.0208C21.0846 9.96229 18.7248 9.10417 15.8138 9.10417C12.9028 9.10417 10.543 9.96229 10.543 11.0208M21.0846 11.0208V18.2083C21.0846 19.2669 18.7248 20.125 15.8138 20.125C12.9028 20.125 10.543 19.2669 10.543 18.2083V11.0208M21.0846 14.6146C21.0846 15.6731 18.7248 16.5312 15.8138 16.5312C12.9028 16.5312 10.543 15.6731 10.543 14.6146",
    stroke: "#EE54FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsImg);
export default __webpack_public_path__ + "static/media/credits_img.6c13375dbd32fcdf60a813ea44dd8285.svg";
export { ForwardRef as ReactComponent };